// extracted by mini-css-extract-plugin
export default {"tooltip":"Ho-z","sharingV2":"Io-z","sharingIconsV2":"Jo-z","links":"Ko-z","link":"Lo-z","facebookV2":"Mo-z","twitterV2":"No-z","pinterestV2":"Oo-z"};